type Taggable = {
	Tags: string[];
}

export function isTaggable<T>(obj: T): obj is T & Taggable {
	return !!obj && (obj as any).Tags instanceof Array;
}

export function showTagFilter<T>(items: T[], allowedTags: string[]): boolean {

	// Si no hay nada taggable, no muestro filtro
	if (items.some(isTaggable) === false)
		return false;

	// Si sólo se permite una etiqueta, no muestro filtro porque todos los items tendrán esa etiqueta
	if (allowedTags.length === 1)
		return false;

	return true;
}

export function getDistinctTags<T>(items: T[]): string[] {
	return items.flatMap(x => isTaggable(x) ? x.Tags : []).groupBy(x => x).map(x => x.key).sortBy(x => x);
}

export function filterByTags<T>(items: T[], tags: string[]): T[] {
	return tags.length === 0
		? items
		: items.filter(x => isTaggable(x) && tags.some(tag => x.Tags.includes(tag)));
}
